#import "./TorahMelodyDetails.graphql"
query TorahMelodiesQuery {
  torahMelodies {
    ...torahMelodyDetails
  }
}
